export const ALL_TASKS = 'all';
export const PENDING_TASKS = 'pending';
export const COMPLETED_TASKS = 'done';
export const IMPORTANT_TASKS = 'important';
export const LATE_TASKS = 'late';